<template>
  <CalcPanel titulo="Estado de los datos">
    <div v-if="faltan.length" class="cdn-state miss">
      <span class="ico">!</span>
      <div>
        <b>{{ faltan[0] }}</b>
        <span v-if="faltan.length > 1" class="cdn-note">Y {{ faltan.length - 1 }} dato{{ faltan.length > 2 ? 's' : '' }} más: {{ faltan.slice(1).join(' · ') }}. Sin ellos el precio sale incompleto.</span>
        <span v-else class="cdn-note">Sin este dato el precio sale incompleto.</span>
      </div>
    </div>
    <!-- Los avisos de la definición de la herramienta («Piscinas: mínimo 2 cuadros»). Con alguno a la
         vista no se dice «Datos suficientes»: los dos juntos dirían que todo está bien y que no (#961). -->
    <div v-for="(a, i) in avisos" :key="'av' + i" class="cdn-state miss">
      <span class="ico">!</span>
      <div><b>{{ a }}</b><span class="cdn-note">Lo avisa la herramienta para este tipo de inspección; el precio se calcula igual con lo tecleado.</span></div>
    </div>
    <div v-if="!faltan.length && !avisos.length" class="cdn-state ok">
      <span class="ico">✓</span>
      <div>
        <b>Datos suficientes</b>
        <span v-if="resumen" class="cdn-note">{{ resumen }}</span>
      </div>
    </div>
  </CalcPanel>
</template>

<script>
import CalcPanel from './CalcPanel.vue';

/**
 * Lo que falta para dar el precio por bueno. La lista la da el cálculo de cada herramienta: este
 * componente sólo la cuenta. A diferencia de la maqueta, nombra TODOS los datos que faltan y no sólo
 * el primero: «Y 2 datos más» obliga a ir rellenando a ciegas hasta dar con ellos.
 */
export default {
  components: { CalcPanel },
  props: {
    faltan: { type: Array, default: function () { return []; } },
    resumen: { type: String, default: '' },
    // Las alertas de la herramienta que se cumplen. RITE las enseña en su propio bloque de calor y no
    // pasa ninguna; Baja Tensión no tiene otro sitio donde decirlas (#961).
    avisos: { type: Array, default: function () { return []; } }
  }
};
</script>
